import { Box, Typography } from '@material-ui/core'

import { useStyles } from './styles'

interface EmptyComponentProps {
  title: string
  subtitle: string
  button?: React.ReactNode
}

export function EmptyComponent({
  title,
  subtitle,
  button,
}: EmptyComponentProps) {
  const classes = useStyles()

  return (
    <Box
      width='100%'
      height='100%'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Box
        display='flex'
        flexDirection='column'
        width='35rem'
        textAlign='center'
        gridGap='0.5rem'
      >
        <Typography variant='subtitle2'>{title}</Typography>
        <Typography variant='subtitle1' style={{ lineHeight: '16px' }}>
          {subtitle}
        </Typography>
        <Box className={classes.btn}>{button && button}</Box>
      </Box>
    </Box>
  )
}
